export default "__VITE_ASSET__Bu_vPQs3__"